// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/PlatformWebhooks_CatalogResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/** GET /platform-webhooks/catalog */
import type { PlatformWebhooks_EventRow } from './PlatformWebhooks_EventRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface PlatformWebhooks_CatalogResponseDados {
version: number
rows: PlatformWebhooks_EventRow[]
}

export type PlatformWebhooks_CatalogResponse = ApiResponse<PlatformWebhooks_CatalogResponseDados>;

registerResponseContract('PlatformWebhooks_CatalogResponse', {
  version: { type: 'number',  required: true },
  rows: {
    type: 'array',
    required: true,
    items: {
      name:        { type: 'string',  required: false },
      description: { type: 'string',  required: false },
      sample:      { type: 'object',  required: false },
    },
  },
})
